import {Button, Checkbox, FormControlLabel, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import FunctionsData from "../functions/FunctionsData";

export default function Step04(props) {
	
	const [valid, setValid] = useState(false);
	const [hideButton, setHideButton] = useState(false);
	const [existingUser, setExistingUser] = useState(false);
	
	function isEmail(val) {
		let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regEmail.test(val);
	}
	
	useEffect(() => {
		window.analytics.track("Signup Stage", {
			stage: 1,
			"Stage name": "Password"
		});
	}, []);
	
	useEffect(() => {
		setValid(
			isEmail(props.state.frmContactEmail) &&
			props.state.frmPassword === props.state.frmPasswordConfirm &&
			props.state.frmPassword !== '' &&
			validatePassword(props.state.frmPassword)
		)
	})
	
	function validatePassword(pw) {
		
		return /[A-Z]/.test(pw) &&
			/[a-z]/.test(pw) &&
			/[0-9]/.test(pw) &&
			// /[^A-Za-z0-9]/.test(pw) &&
			pw.length >= 8;
		
	}
	
	function accept() {
		props.setState({
			...props.state,
			frmAcceptedDeclarationDate: new Date(),
			frmAcceptedDeclaration: 1
		})
	}
	
	function slugify(text) {
		return text
			.toString()                           // Cast to string (optional)
			.normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form
			                              // of a given string.
			.toLowerCase()                  // Convert the string to lowercase letters
			.trim()                                  // Remove whitespace from both sides of a string (optional)
			.replace(/\s+/g, '-')            // Replace spaces with -
			.replace(/\-\-+/g, '-');        // Replace multiple - with single -
	}
	
	function checkUsername(val) {
		
		const valNew = slugify(val);
		props.setState({...props.state, username: valNew});
		FunctionsData.postData(
			FunctionsData.getApiUrl('/api/register/check/user'),
			{username: valNew}
		).then((r) => {
			if (r.available === true) {
				setExistingUser(false);
			} else {
				setExistingUser(true);
			}
		})
	}
	
	return (
		<div>
			<div className={"form-box"}>
				<h4>
					Your username to access your portal: <span style={{color: 'red'}}>{
						(existingUser === true) ? "n/a" : props.state.username
					}</span>
				</h4>
				<h4>
					URL of your portal: <span style={{color: 'red'}}>https://vet.spcadesexing.nz</span>
				</h4>
				<small>Please remember those, as well as the password you set below.</small>
				<hr style={{margin: '20px 0', width: '100%'}}/>
				
				<div>
					<p>Change your username*</p>
					<TextField value={props.state.username} focused
					           type={"text"}
					           onChange={(e) => {
						           checkUsername(e.target.value)
					           }}
					           error={props.state.username === '' || existingUser === true}
					/>
					{
						(existingUser === true) ?
							<small style={{color:'red'}}>This username has already been registered.</small>
							: undefined
					}
				</div>
				
				<p>
					Please set a password for accessing the Vet portal.
				</p>
				
				<div>
					<p>Password*</p>
					<TextField value={props.state.frmPassword} focused
					           type={"password"}
					           onChange={(e) => props.setState({...props.state, frmPassword: e.target.value})}
					           error={props.state.frmPassword === '' || !validatePassword(props.state.frmPassword)}
					/>
					{
						(validatePassword(props.state.frmPassword) === false) ?
							<small>Please use a stronger password.
							We require a minimum of 8 characters, with lower and upper case as well as numbers.</small>
							: undefined
					}
				</div>
				
				<div>
					<p>Confirm your password*</p>
					<TextField value={props.state.frmPasswordConfirm} focused
					           type={"password"}
					           onChange={(e) => props.setState({...props.state, frmPasswordConfirm: e.target.value})}
					           error={props.state.frmPassword === '' || props.state.frmPasswordConfirm !== props.state.frmPassword}
					/>
				</div>
				
				<div>
					<Button color="primary" sx={{p: '15px', marginLeft: 0}} aria-label="directions"
					        variant={"contained"}
					        onClick={() => {
						        setHideButton(true);
						        props.registerVet()
					        }}
					        disabled={(!valid) || existingUser === true || hideButton === true}
					>
						{(hideButton === true) ? "We are getting your registration ready..." : "Finish and submit"}
					</Button>
					<Button color="primary" sx={{p: '15px', marginLeft: 0}} aria-label="directions"
					        variant={""}
					        onClick={() => props.setStep(props.step - 1)}>
						Back
					</Button>
				</div>
			
			</div>
		</div>
	)
}
